import { observer } from 'mobx-react';
import React from 'react';
import errorsPerAbilityChartService from '../../services/ErrorsPerAbilityChartService';
import ErrorsPerAbilityChart from './ErrorsPerAbilityChart';

function GlobalErrorsPerAbilityChartContainer() {
  return (
    <ErrorsPerAbilityChart
      data={errorsPerAbilityChartService.data}
      isFetching={errorsPerAbilityChartService.fetch.fetching}
    />
  );
}

export default observer(GlobalErrorsPerAbilityChartContainer);
